module.exports = __webpack_public_path__ + "static/media/scannerwithman2.2381b88e.gif";